import {apolloClient} from 'shared/apollo'
import updateSessionScreenshotMarkersMutation from 'shared/graphql/updateSessionScreenshotMarkers.gql'
import querySession from 'shared/graphql/querySession.gql'

export default async function updateSessionScreenshotMarkers({sessionId, screenshotMarkers, userId}) {
	await apolloClient.mutate({
		mutation: updateSessionScreenshotMarkersMutation,
		variables: {
			sessionId,
			screenshotMarkers,
		},
		update(cache, response) {
			if (!response.data.update_sessions_by_pk) {
				throw new Error(`Session ${sessionId} screenshot markers could not be updated`)
			}

			const variables = {id: sessionId, userId, isUserWorkspaceMember: true}
			let data = cache.readQuery({query: querySession, variables})
			if (!data?.session) return

			data = JSON.parse(JSON.stringify(data))
			data.session.screenshotMarkers = response.data.update_sessions_by_pk.screenshotMarkers

			cache.writeQuery({query: querySession, variables, data})
		},
		optimisticResponse: {
			update_sessions_by_pk: {
				__typename: 'sessions',
				screenshotMarkers,
			},
		},
	})
}
